export const DEFAULT_ENVIRONMENT = 'production';
export const DEV_ENVIRONMENT = 'development';
